import React from "react";
import { Link } from "react-router-dom";

const TileComp = (props)=>{
    const moreLink = `/${props.moreLink}`;

    return(
        <div className="tile-item">
            <div className="tile-header">
                <h4>{props.title}</h4>
            </div>
            <div className="tile-body">
                {props.children}
            </div>
            <div className="tile-footer">
                <div className="tile-footer-label">{props.footer}</div>
                {props.moreLink && (
                <div className="tile-footer-tool">
                    <Link className="flex" to={moreLink}>
                        Show more
                        <img className="icon ml-3" src="img/icon/right.svg" alt="icon show more"/>
                    </Link>
                </div>
                )}
            </div>
        </div>
    );

};

export default TileComp;